import { render, staticRenderFns } from "./ColumnMADD.vue?vue&type=template&id=940beb00&scoped=true"
import script from "./ColumnMADD.vue?vue&type=script&lang=js"
export * from "./ColumnMADD.vue?vue&type=script&lang=js"
import style0 from "./ColumnMADD.vue?vue&type=style&index=0&id=940beb00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940beb00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('940beb00')) {
      api.createRecord('940beb00', component.options)
    } else {
      api.reload('940beb00', component.options)
    }
    module.hot.accept("./ColumnMADD.vue?vue&type=template&id=940beb00&scoped=true", function () {
      api.rerender('940beb00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnMADD.vue"
export default component.exports